import { TestAuth } from '../components/features/debug/TestAuth';
import { TestFlows } from '../components/features/debug/TestFlows';

export default function DebugPage() {
  return (
    <div className="container mx-auto px-4 py-8 mt-52">
      <h1 className="text-2xl font-bold mb-8">Debug Tools</h1>
      <TestAuth />
      <TestFlows />
    </div>
  );
}
